
import React from "react";
import { RangeSlider, SliderLabel } from "@progress/kendo-react-inputs";
import "./rangeslider.scss";

// interface to declare all our prop types
interface Props {
  onChange?: any;
  defaultValue?: any;
}

const RageSelector: React.FC<Props> = ({
  onChange,
  defaultValue,
  ...rest
}) => {
  

  const [start, setStart] = React.useState(0);
  
  return (

    <div className="rangeSlider"> 
        <RangeSlider
          onChange={(e : any) => onChange(e)}
          defaultValue={{
            start: defaultValue && defaultValue.min ? defaultValue.min : start ,
            end: defaultValue && defaultValue.max ? defaultValue.max : 20 ,
          }}
          step={1}
          min={0}
          max={20}
        >
          {[0, 2, 4, 6, 8, 10, 12,14,16,18,20].map((perc, i) => (
            <SliderLabel key={i} position={perc}>
              {perc.toString()}
            </SliderLabel>
          ))}
        </RangeSlider>
    </div>
  );
};

export default RageSelector;
